<template>
    <DModal
        :show="showModal"
        :title="item.name"
        :is-awaiting-validation="true"
        is-medium
        @close="$emit('close-modal')"
    >
        <div class="overflow">
            <DCard padding>
                <div
                    v-for="(comment, index) in item.comments"
                    :key="index"
                    :class="index === 0 ? '' : 'margin-top'"
                >
                    <DFormTextarea
                        :id="`comments_${index}`"
                        :value="comment.message"
                        disabled
                        rows="2"
                    />
                </div>

                <div
                    v-if="canAddComment"
                    class="margin-top"
                >
                    <DFormTextarea
                        id="comment"
                        v-model="form.comment"
                        :placeholder="__('orders.check.new_message')"
                        rows="2"
                    />
                </div>

                <p
                    v-for="(error, index) in errors"
                    :key="index"
                    class="error-msg"
                >
                    {{ error }}
                </p>
            </DCard>
        </div>
        <template #actions>
            <div
                v-if="canAddComment"
                class="action-buttons"
            >
                <DButton
                    :label="__('orders.check.save_message')"
                    color="secondary"
                    class="margin-r-5"
                    @click="saveClarificationComment"
                />
                <DButton
                    v-if="item.solved === false && userPermissions.includes('order.accept')"
                    :label="__('orders.check.set_solved')"
                    color="secondary"
                    @click="solveClarification()"
                />
            </div>
        </template>
    </DModal>
</template>

<script>

export default {
    name: 'ClarificationModal',
    props: {
        item: {
            type: Object,
            default: () => { return {} }
        },
        order: {
            type: Object,
            default: () => { return {} }
        },
        showModal: {
            type: Boolean,
            default: false
        },
        editable: {
            type: Boolean,
            default: true
        },
        checkId: {
            type: Number,
            default: null
        },
        settingCheckId: {
            type: Number,
            default: null
        }
    },
    emits: ['close-modal', 'update:showModal'],
    data () {
        return {
            form: this.$inertia.form({
                comment: null,
                psa_manual_check_id: this.checkId,
                psa_manual_check_setting_id: this.settingCheckId,
                order_id: this.order.orderData.id
            }),
            errors: {}
        }
    },
    computed: {
        userPermissions () {
            return this.$page.props.auth.permissions
        },
        canAddComment () {
            return this.item.solved === false &&
                (
                    (
                        (this.order.status === 'clarification_external' || this.order.status === 'clarification_internal') &&
                        this.userPermissions.includes('order.view')
                    ) ||
                    (
                        (this.order.status === 'screening' || this.order.status === '4_eyes_check' || this.order.status === 'clarification_external' || this.order.status === 'clarification_internal') &&
                        this.userPermissions.includes('order.accept')
                    )
                )
        }
    },
    methods: {
        saveClarificationComment () {
            this.$inertia.post(
                this.$route('orders.psa.save-clarification-comment'),
                this.form,
                {
                    onSuccess: () => {
                        this.$emit('close-modal')
                    },
                    onError: (error) => {
                        this.errors = error
                    }
                }
            )
        },
        solveClarification () {
            this.$inertia.post(
                this.$route('orders.psa.solve-clarification'),
                this.form,
                {
                    onSuccess: () => {
                        this.$emit('close-modal')
                    },
                    onError: (error) => {
                        this.errors = error
                    }
                }
            )
        }
    }
}
</script>

<style lang="scss" scoped>
.error-msg {
    margin: 3px 0 0 0;
    font-size: 12px;
    text-align: left;
    color: var(--colorDanger);
}
.margin-top {
    margin-top: 15px;
}
.action-buttons {
    width: 100%;
    text-align: right;
}
.margin-r-5 {
    margin-right: 5px;
}
.overflow {
    overflow-y: auto !important;
}
</style>
